import { type Enum } from '@webapp/infrastructure/types/Enum'

export const GuidedIntakeEntryPoints = {
  GLOBAL_SEARCH: 'global_search',
  ORDER_REQUEST_EMPTY_STATE: 'order_request_empty_state',
  AMAZON_PUNCHOUT_MODAL: 'amazon_punchout_modal',
  REQUEST_DROPDOWN: 'request_dropdown',
  SEARCH_OVERLAY: 'search_overlay',
} as const

export type GuidedIntakeEntryPointEnum = Enum<typeof GuidedIntakeEntryPoints>
